module.exports = __webpack_public_path__ + "img/BDI.f9374abd.svg";